import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";

// Dashboard
import Devices from "../pages/Devices/index";
import Payment from "../pages/Payment/index";
import LifeTimeEmail from "../pages/LifeTimeEmails/index";
import GetInTouch from "../pages/GetInTouch/index";
import UnisatallSurvey from "../pages/UninstallSurvey/index.js";
import PaymentIssues from "../pages/PaymentIssues/index.js";
import IOSBetaEmail from "../pages/iOS/iOSBetaEmails/index.js";
import MissingApps from "../pages/iOS/iOSmissingApp/index.js";
import Subscriptions from "../pages/iOS/subscriptions/index.js";
import AddnewApp from "../pages/iOS/AddNewApp/addNewApp.js";

import Chat from "../pages/iOS/Chat/Chat";

import Maintenance from "../pages/Utility/Maintenance";
import CommingSoon from "../pages/Utility/CommingSoon";
import Error404 from "../pages/Utility/Error404";
import Error500 from "../pages/Utility/Error500";
import Dashboard from "../pages/Dashboard/index.js";
import UploadGlassesApk from "../pages/Glasses/UploadApk/uploadGlassesApk.js";

const authProtectedRoutes = [
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/devices", component: <Devices /> },
  { path: "/payment", component: <Payment /> },
  { path: "/view_lifeTime_email", component: <LifeTimeEmail /> },
  { path: "/viewEmails", component: <GetInTouch /> },
  { path: "/uninstallSurvey", component: <UnisatallSurvey /> },
  { path: "/paymentIssue", component: <PaymentIssues /> },

  { path: "/addNewApp", component: <AddnewApp /> },
  { path: "/glassesApk", component: <UploadGlassesApk /> },

  { path: "/chat", component: <Chat /> },
  { path: "/iosBetaSubscriber", component: <IOSBetaEmail /> },
  { path: "/iOS-missing-app", component: <MissingApps /> },
  { path: "/ios-subscriptions", component: <Subscriptions /> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },

  { path: "/maintenance", component: <Maintenance /> },
  { path: "/comingsoon", component: <CommingSoon /> },
  { path: "/404", component: <Error404 /> },
  { path: "/500", component: <Error500 /> },
];

export { authProtectedRoutes, publicRoutes };
